const Bio = () => {
  return (
    <div className="bio">
      <section className="about-me">
        <p>
          Hi, I'm a software developer based in Luton, England. I'm really
          passionate about bringing my ideas to life through code and I'm
          tremendously passionate about it, even when I'm tearing my hair out
          over being stuck on a particular problem for hours on end! <br></br>
        </p>
        <p>
          I'm new to the industry, but I am confident in being able to learn.{" "}
        </p>

        <p>
          I'm a huge football fan and supporter of Manchester United, go reds!{" "}
        </p>

        <p>
          I do a lot of work with Revive Family & Youth Services, an
          organisation that seeks to provide support to the local community.
          Check them out <a href="https://revivefys.org/">here</a>{" "}
        </p>
      </section>
    </div>
  );
};

export default Bio;
